/* import __COLOCATED_TEMPLATE__ from './item-category-filter.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { isNone, isEmpty, isPresent } from '@ember/utils';
import { computed, action } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
// eslint-disable-next-line ember/no-mixins
import SearchFilterSupport from '@dashboard/junk-drawer/mixins/search-filter-support';
let ItemCategoryFilter = (_dec = computed('filteredCategories.[]', 'categories.[]'), (_class = class ItemCategoryFilter extends Component.extend(SearchFilterSupport) {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _defineProperty(this, "searchFilterText", '');
    _defineProperty(this, "searchProperties", ['name']);
    // passed in
    _defineProperty(this, "categoryFilterLabel", null);
    _defineProperty(this, "categories", []);
    _defineProperty(this, "nextPageToken", '');
    _defineProperty(this, "selectedCategory", null);
  }
  get listCategories() {
    const filteredCategories = this.filteredCategories;
    if (!isNone(filteredCategories)) {
      return filteredCategories;
    } else {
      return this.categories;
    }
  }
  handleOnChange() {
    if (!isEmpty(this.searchFilterText)) {
      // Clear search term and filtering, reset back to original state
      this.set('searchFilterText', '');
      this.set('filteredCategories', null);
    }
    this.onChange?.(this.selectedCategory);
  }
  updateFilter() {
    const filterString = this.searchFilterText;
    if (isEmpty(filterString)) {
      this.set('filteredCategories', null);
      return;
    }
    if (isPresent(this.nextPageToken)) {
      // each search starts at page 0 so pass '' for the paginationToken
      this.store.query('category', {
        pageSize: 50,
        text: filterString
      }).then(categories => {
        if (this.searchFilterText === filterString) {
          this.set('filteredCategories', categories);
        }
      });
    } else {
      // if nextPageToken is empty it means we've loaded all the categories so we can do local search
      const filteredCategories = this.filterObjectsBySearch(this.categories, filterString);
      this.set('filteredCategories', filteredCategories);
    }
  }
  loadNextPage() {
    if (isNone(this.filteredCategories)) {
      const nextPageToken = this.nextPageToken;
      if (isPresent(nextPageToken)) {
        this.set('nextPageIsLoading', true);
        this.store.query('category', {
          paginationToken: nextPageToken,
          pageSize: 50
        }).then(categories => {
          this.categories.addObjects(categories.toArray());
          this.set('nextPageIsLoading', false);
          const nextPageToken = categories.meta?.nextPageToken || '';
          this.set('nextPageToken', nextPageToken);
        });
      }
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "listCategories", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "listCategories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleOnChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleOnChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadNextPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadNextPage"), _class.prototype)), _class));
export { ItemCategoryFilter as default };